import * as localStore from 'store/utils/localStorage';
import * as sessionStore from 'store/utils/sessionStorage';
import ErrorHandler from 'store/utils/ErrorHandler';
import Notify from 'store/utils/Notify';
import * as api from './api';
import * as types from './actionTypes';

export const refreshToken = token => dispatch => {
  try {
    dispatch({
      type: types.REFRESH_TOKEN,
      payload: {
        token,
      },
    });
  } catch (err) {
    ErrorHandler.parseValidationError(err.response);
  }
};

export const pairAccount = data => dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      await api.pairAccount(data);
    } catch (err) {
      Notify.error({
        title: 'An error occurred',
        description: ErrorHandler.getNotificationError(err),
      });
      reject(err);
      return;
    }

    dispatch({
      type: types.LOGIN_USER_SUCCESS,
      payload: {
        token: data.keycloak_token,
        user: {
          email: data.email,
        },
      },
    });

    resolve();
  });

export const loginUserUsingKeycloak = keycloak => async dispatch =>
  new Promise(async (resolve, reject) => {
    let user = null;

    try {
      user = await api.tokenIntrospectionRequest(keycloak.token);
    } catch (err) {
      reject(err);
      return;
    }

    dispatch({
      type: types.LOGIN_USER_SUCCESS,
      payload: {
        token: keycloak.token,
        user: {
          email: keycloak.tokenParsed.email,
        },
      },
    });

    dispatch({
      type: types.GET_USER_DATA,
      payload: {
        user: user.data,
      },
    });

    resolve();
  });

export const loginUser = data => async dispatch => {
  try {
    await dispatch({
      type: types.LOGIN_USER_REQUEST,
    });

    const response1 = await api.loginUserRequest(data);

    await dispatch({
      type: types.LOGIN_USER_SUCCESS,
      payload: {
        token: response1.data.authentication_token,
        user: {
          email: data.email,
        },
      },
    });

    const response2 = await api.getUserRequest();

    await dispatch({
      type: types.GET_USER_DATA,
      payload: {
        user: response2.data,
      },
    });
  } catch (err) {
    await dispatch({
      type: types.LOGIN_USER_ERROR,
      payload: {
        error: err.response.data,
      },
    });

    ErrorHandler.parseValidationError(err.response);
  }
};

export const logoutUser = () => async dispatch => {
  try {
    await dispatch({
      type: types.LOGOUT_USER_REQUEST,
    });

    await api.logoutUserRequest();

    await dispatch({
      type: types.LOGOUT_USER_SUCCESS,
    });

    localStore.removeState('nlu');
    sessionStore.removeState('nlu');

    window.location.href = '/sign_in';
  } catch (error) {
    await dispatch({
      type: types.LOGOUT_USER_ERROR,
      payload: {
        error: error.response.data,
      },
    });

    Notify.error({
      title: 'An error occurred',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

export const forgotPassword = data => async dispatch => {
  try {
    await dispatch({
      type: types.FORGOT_PASSWORD_REQUEST,
    });

    await api.forgotPasswordRequest(data);

    await dispatch({
      type: types.FORGOT_PASSWORD_SUCCESS,
    });

    Notify.success({
      title: 'Please check your inbox for a link to reset your password',
    });
  } catch (err) {
    await dispatch({
      type: types.FORGOT_PASSWORD_ERROR,
      payload: {
        error: err.response.data,
      },
    });

    ErrorHandler.parseValidationError(err.response);
  }
};

export const resetPassword = data => async dispatch => {
  try {
    await dispatch({
      type: types.RESET_PASSWORD_REQUEST,
    });

    await api.resetPasswordRequest(data);

    await dispatch({
      type: types.RESET_PASSWORD_SUCCESS,
    });

    Notify.success({
      title: 'Password was reset successfully!',
    });

    setTimeout(() => {
      window.location.href = '/sign_in';
    }, 1000);
  } catch (err) {
    await dispatch({
      type: types.RESET_PASSWORD_ERROR,
      payload: {
        error: err.response.data,
      },
    });

    ErrorHandler.parseValidationError(err.response);
  }
};

export const updateUser = data => async dispatch => {
  try {
    await dispatch({
      type: types.UPDATE_USER_REQUEST,
    });

    await api.updateUserRequest(data);

    await dispatch({
      type: types.UPDATE_USER_SUCCESS,
      payload: {
        user: data,
      },
    });

    Notify.success({
      title: 'Your username was updated successfully!',
    });
  } catch (error) {
    await dispatch({
      type: types.UPDATE_USER_ERROR,
      payload: {
        error: error.response.data,
      },
    });

    Notify.error({
      title: 'Fail to update User',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};

export const updatePassword = data => async dispatch => {
  try {
    await dispatch({
      type: types.UPDATE_PASSWORD_REQUEST,
    });

    await api.updatePasswordRequest(data);

    await dispatch({
      type: types.UPDATE_PASSWORD_SUCCESS,
    });

    Notify.success({
      title: 'Your password was updated successfully!',
    });
  } catch (err) {
    await dispatch({
      type: types.UPDATE_PASSWORD_ERROR,
      payload: {
        error: err.response.data,
      },
    });

    ErrorHandler.parseValidationError(err.response);
  }
};

export const updateAvatar = data => async dispatch => {
  try {
    await dispatch({
      type: types.UPDATE_AVATAR_REQUEST,
    });

    const response = await api.updateAvatarRequest(data);

    await dispatch({
      type: types.UPDATE_AVATAR_SUCCESS,
      payload: {
        avatar: response.data.avatar,
      },
    });

    Notify.success({
      title: 'Your avatar was updated successfully!',
    });
  } catch (error) {
    await dispatch({
      type: types.UPDATE_AVATAR_ERROR,
      payload: {
        error: error.response.data,
      },
    });

    Notify.error({
      title: 'Fail to update Avatar',
      description: ErrorHandler.getNotificationError(error),
    });
  }
};
